export const INVOICE_PATTERN_REGEX = /^(?:[A-Z]{1,5}(?: - |-)?)?\d{1,5}$/;

export const invoicePatternErrorMessage =
  'Invoice pattern must include 1–5 digits; optional letters (up to 5), optionally separated by "-" or " - " (e.g. STA001, STB-00001, ST - 001, or 00001)';

export const normalizeInvoicePattern = (value) => {
  if (typeof value !== 'string') return value;

  const upper = value.toUpperCase().trim().replace(/\s+/g, ' ');
  if (!upper) return upper;

  const digitsOnly = upper.match(/^(\d{1,5})$/);
  if (digitsOnly) return digitsOnly[1];

  const spaced = upper.match(/^([A-Z]{1,5}) - (\d{1,5})$/);
  if (spaced) return `${spaced[1]} - ${spaced[2]}`;

  const dashed = upper.match(/^([A-Z]{1,5})-(\d{1,5})$/);
  if (dashed) return `${dashed[1]}-${dashed[2]}`;

  const glued = upper.match(/^([A-Z]{1,5})(\d{1,5})$/);
  if (glued) return `${glued[1]}${glued[2]}`;

  const loose = upper.match(/^([A-Z]{1,5})\s*-\s*(\d{1,5})$/);
  if (loose) {
    const sep = /-\s|\s-/.test(upper) ? ' - ' : '-';
    return `${loose[1]}${sep}${loose[2]}`;
  }

  return upper;
};

export const isValidInvoicePattern = (value) => {
  const normalized = normalizeInvoicePattern(value);
  return typeof normalized === 'string' && INVOICE_PATTERN_REGEX.test(normalized);
};

/**
 * Live input formatter:
 * - optional letters (max 5), required digits on submit (max 5)
 * - preserves "", "-" vs " - " (no auto-insert dash when typing digits after letters)
 */
export const formatInvoicePatternInput = (raw) => {
  const upper = String(raw || '').toUpperCase();
  let letters = '';
  let digits = '';
  let seenDash = false;
  let spacedSep = false;
  let mode = 'letters';

  for (let i = 0; i < upper.length; i += 1) {
    const ch = upper[i];

    if (mode === 'letters') {
      if (/[A-Z]/.test(ch)) {
        if (letters.length < 5) letters += ch;
        continue;
      }
      if (ch === ' ' || ch === '-') {
        if (letters.length === 0) continue;
        mode = 'sep';
        if (ch === '-') seenDash = true;
        if (ch === ' ') spacedSep = true;
        continue;
      }
      if (/[0-9]/.test(ch)) {
        mode = 'digits';
        if (digits.length < 5) digits += ch;
      }
      continue;
    }

    if (mode === 'sep') {
      if (ch === ' ') {
        spacedSep = true;
        continue;
      }
      if (ch === '-') {
        seenDash = true;
        continue;
      }
      if (/[0-9]/.test(ch)) {
        mode = 'digits';
        if (digits.length < 5) digits += ch;
      }
      continue;
    }

    if (mode === 'digits' && /[0-9]/.test(ch) && digits.length < 5) {
      digits += ch;
    }
  }

  if (!letters && !digits) return '';
  if (!letters) return digits;
  if (!digits) {
    if (seenDash || spacedSep) {
      return spacedSep ? `${letters} - ` : `${letters}-`;
    }
    return letters;
  }

  if (!seenDash && !spacedSep) {
    return `${letters}${digits}`;
  }
  const sep = spacedSep ? ' - ' : '-';
  return `${letters}${sep}${digits}`;
};
